export var dataKey = 'text';


//////////////////
// WEBPACK FOOTER
// ../~/redux-form/es/util/eventConsts.js
// module id = 2090
// module chunks = 0